import React from 'react'
import styled, { css } from 'styled-components'

import Icon from '../../../../components/Icon'
import Heading from '../../../../components/Heading'
import Text from '../../../../components/Text'
import { colors, mediaQueries, spacing } from '../../../../tokens'

interface StyledProps {
  completed: boolean
}

interface Props {
  image: string
  name: string
  resumen: string
  isAccessPro: boolean
  completed: boolean
  userIsPro: boolean
  isPonderable: boolean
  category: string
  filledRequirements: boolean | undefined
  onClick(): void
  onRestrictContent(): void
}

function TextOrLinkLesson({
  image,
  name,
  resumen,
  isAccessPro,
  completed,
  userIsPro,
  isPonderable,
  category,
  filledRequirements = false,
  onClick,
  onRestrictContent,
}: Props) {
  let locked = false
  if (!userIsPro) {
    locked = isAccessPro
  }

  function handleClickItem(): void {
    if (!locked) {
      onClick()
    } else {
      onRestrictContent()
    }
  }

  function getCornerIcon(): React.ReactNode {
    if (locked) {
      return (
        <Status completed={false}>
          <Icon name="padlock" status="default" />
        </Status>
      )
    }

    let cornerIcon: React.ReactNode | null = null
    if (isPonderable) {
      const isCompleted =
        category === 'requirement' ? filledRequirements : completed
      cornerIcon = (
        <Status completed={isCompleted}>
          <Icon name="check" status="white" />
        </Status>
      )
    }
    return cornerIcon
  }

  return (
    <Wrapper onClick={handleClickItem}>
      <ImageContainer>
        {image ? (
          <Image src={image} alt={'nombre'} />
        ) : (
          <Icon name="questions" size="large" />
        )}
      </ImageContainer>
      <Info>
        <Heading size={3}>{name}</Heading>
        {resumen && <Text status="light">{`${resumen}`}</Text>}
      </Info>
      {getCornerIcon()}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  align-items: flex-start;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
`

const ImageContainer = styled.div`
  align-items: center;
  align-self: center;
  background-color: ${colors.light().background};
  display: flex;
  height: auto;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  @media ${mediaQueries.smallMin} {
    width: 250px;
    height: 130px;
  }
`

const Image = styled.img`
  width: 100%;
  height: auto;
`

const Info = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${spacing.small};
  @media ${mediaQueries.smallMin} {
    padding: ${spacing.xsmall} ${spacing.small};
  }
`

const Status = styled.div<StyledProps>`
  align-items: center;
  ${props =>
    props.completed
      ? css`
          background-color: ${colors.success().color};
        `
      : css`
          background-color: ${colors.light().background};
        `}
  border-radius: 50%;
  display: flex;
  justify-content: center;
  margin: ${spacing.small};
  @media ${mediaQueries.smallMin} {
    margin: ${spacing.xsmall};
  }
`

export default TextOrLinkLesson
